module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-5-08ea86fb9ba7e8273493fd456ebf5dec.png";